module.exports = __webpack_public_path__ + "img/html5.a075d50d.png";